/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { LuigisBox_SearchAnalytics } from '../models/LuigisBox_SearchAnalytics';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LuigisBoxService {
    /**
     * Upload visible search results to Luigi's Box analytics
     * @returns void
     * @throws ApiError
     */
    public static uploadSearchAnalytics({
        requestBody,
        apiVersion = 1,
    }: {
        requestBody: LuigisBox_SearchAnalytics,
        apiVersion?: number,
    }): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v{apiVersion}/luigi/analytics/search',
            path: {
                'apiVersion': apiVersion,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Validation error.`,
                401: `An error occurred.`,
                500: `An error occurred.`,
            },
        });
    }
}
